import { Box, Link, Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { Semibold } from '@/imports/ui/chakra/components/Semibold';
import { formatPhoneNumber } from '@/utilities';

export const DeprecatedDialInInfo: React.FC<{
  dialInEnabled?: boolean | null;
  eventName?: string | null;
  dialInCode?: string | null;
  listenerDialInCode?: string | null;
  dialInPhoneNumber?: string | null;
  isCurrentUserSpeaker?: boolean | null;
  isParticipationAllowed?: boolean | null;
}> = ({
  dialInEnabled,
  eventName,
  dialInPhoneNumber,
  isParticipationAllowed,
  isCurrentUserSpeaker,
  dialInCode,
  listenerDialInCode,
}) => {
  if (!dialInEnabled) {
    return null;
  }

  const formattedPhoneNumber = formatPhoneNumber(dialInPhoneNumber || '');

  return (
    <Stack spacing="4">
      <Stack spacing="4">
        <Text textStyle="xlBodyStrong">Dial in info</Text>
        <Text>
          To dial into &quot;{eventName}&quot;, call{' '}
          <Link
            whiteSpace="nowrap"
            display="inline-block"
            href={`tel:${dialInPhoneNumber}`}
          >
            {formattedPhoneNumber}
          </Link>
        </Text>
      </Stack>

      <Stack spacing="0">
        {(isParticipationAllowed || isCurrentUserSpeaker) && (
          <Box>
            <Text as="span">To join as a participant, enter code </Text>
            <Text as="b" whiteSpace="nowrap" display="inline-block">
              {dialInCode}
            </Text>
          </Box>
        )}
        <Box>
          <Text as="span">To join as a listener, enter code </Text>
          <Text as="b" whiteSpace="nowrap" display="inline-block">
            {listenerDialInCode}
          </Text>
        </Box>
      </Stack>
    </Stack>
  );
};

export const DialInInfo: React.FC<{
  eventName: string;
  dialInPhoneNumber: string;

  dialInCode: string | null;
  listenerDialInCode: string | null;

  isCurrentUserSpeaker: boolean;
  isParticipationAllowed: boolean;
}> = ({
  eventName,
  dialInPhoneNumber,
  isParticipationAllowed,
  isCurrentUserSpeaker,
  dialInCode,
  listenerDialInCode,
}) => {
  const formattedPhoneNumber = formatPhoneNumber(dialInPhoneNumber);

  return (
    <Stack>
      <Text>
        To dial into &quot;{eventName}&quot; call{' '}
        <Link
          whiteSpace="nowrap"
          display="inline-block"
          href={`tel:${dialInPhoneNumber}`}
        >
          {formattedPhoneNumber}
        </Link>
      </Text>

      {(isParticipationAllowed || isCurrentUserSpeaker) && dialInCode && (
        <Text>
          To join as a participant, enter code{' '}
          <Semibold whiteSpace="nowrap">{dialInCode}</Semibold>
        </Text>
      )}

      {listenerDialInCode && (
        <Text>
          To join as a listener, enter code{' '}
          <Semibold whiteSpace="nowrap">{listenerDialInCode}</Semibold>
        </Text>
      )}
    </Stack>
  );
};
